var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterBike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2815_2320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1475 20.834L36.3933 11.084C35.7529 9.43815 34.0967 8.33398 32.2417 8.33398H26.5V12.5007H32.2417L35.4658 20.834H24.8438L24.0488 18.7506H26.5V14.584H15.4583V18.7506H19.3229L23.3421 29.1673H21.8625C20.8908 24.5215 16.7613 21.084 11.5938 20.8548C5.41042 20.5631 0 25.4173 0 31.2506C0 37.084 4.85833 41.6673 11.0417 41.6673C16.4742 41.6673 20.8688 38.1465 21.8625 33.334H31.1375C32.1092 37.9798 36.2388 41.4173 41.4063 41.6465C47.5896 41.9173 53 37.084 53 31.2298C53 25.3965 48.1417 20.8131 41.9583 20.8131H40.1475V20.834ZM31.1375 29.1673H28.0458L26.4338 25.0006H33.125C32.1533 26.209 31.4467 27.6048 31.1375 29.1673ZM41.9583 37.5006C38.2483 37.5006 35.3333 34.7506 35.3333 31.2506C35.3333 29.3131 36.2388 27.6465 37.6521 26.5006L39.7721 32.0006L43.9238 30.584L41.7817 25.0215C41.8479 25.0215 41.9142 25.0006 41.9804 25.0006C45.6904 25.0006 48.6054 27.7506 48.6054 31.2506C48.6054 34.7506 45.6683 37.5006 41.9583 37.5006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5533 25.2862L9.5533 30.0124L4.54358 30.0124L4.54358 32.5853L9.5533 32.5853L9.5533 37.3114L12.2806 37.3114L12.2806 32.5853H17.2903L17.2903 30.0124L12.2806 30.0124L12.2806 25.2862L9.5533 25.2862Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2815_2320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterBike);
export default __webpack_public_path__ + "static/media/register-bike.2fb2ca00e2d65564fde77c188745fa81.svg";
export { ForwardRef as ReactComponent };